import React from 'react'
let PropTypes = React.PropTypes
// React Notify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// API
import api from '../../apiClient/v1'
// Componentes
import BlackBoxCapturas from './BlackBoxCapturas'
import { PanelAuditoria } from './PanelAuditoria.jsx'
import { TablaIRD, TablaVencimiento, TablaNoEncontrados } from './TablaCaptura.jsx'
import { ModalTrigger, ModalInformarResultado } from './Modales.jsx'
// Formato del Panel Vencimiento (auditor en mayúsculas, rut QF con 'K' final)
import { normalizarPanelVenc } from './panelVencimiento'
// CSS
import * as css from './PanelAuditoria.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class RevisionArchivoFinal extends React.Component{
    constructor(props){
        super(props)
        this.blackbox = new BlackBoxCapturas()
        this.state= {
            auditoria: [],
            capturaIRDFiltrada: [],
            capturaVencimientoFiltrada: [],
            capturaNoEncontradosFiltrada: [],
            listaIRD: [],
            listaVencimiento: [],
            listaNoEncontrados: [],
            filtrosIRD: {},
            filtrosVencimiento: {},
            filtrosNoEncontrados: {},
            error: [],
            showIRD: false,
            showVencimiento: false,
            showNoEncontrados: false,
            enviando: false,
            estado_vencimiento: 0,
            bloqueado: false
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 5*1000);
            }
        }
        this.mostrarIRD = ()=>{
            this.setState({
                showIRD: true,
                showVencimiento: false,
                showNoEncontrados: false
            },()=>this.getCapturaIRD())
        }
        this.mostrarVencimiento = ()=>{
            this.setState({
                showIRD: false,
                showNoEncontrados: false,
                showVencimiento: true
            },()=>this.getCapturaVencimiento())
        }
        this.mostrarNoEncontrados = ()=>{
            if (this.state.listaNoEncontrados.length > 0){
                this.setState({
                    showIRD: false,
                    showNoEncontrados: true,
                    showVencimiento: false
                },()=>this.getCapturaNoEncontrados())    
            }
            else {
                this.refs.notificator.error("Sin registros", "No hay registros de no encontrados.", 5 * 1000)
            }    
        }
        this.onInputChange = (actualizado)=>{
            this.setState({ auditoria: Object.assign({}, this.state.auditoria, actualizado)})
        }

        this.onInputChangeVenc = (actualizado)=>{
            this.setState({ auditoria: { 
                    ...this.state.auditoria,
                    panel_venc: Object.assign({}, this.state.auditoria.panel_venc, actualizado)
                }
            })
        }
        this.getCapturaIRD=()=>{
            this.blackbox.reset()
            let capturasIRD = this.state.listaIRD
            capturasIRD.forEach(captura=>this.blackbox.addIRD(captura))
            this.blackbox.ordenarListaIRD()
            this.setState(this.blackbox.getListaFiltradaIRD())
        }
        this.getCapturaVencimiento=()=>{
            this.blackbox.reset()
            let capturasVencimiento = this.state.listaVencimiento
            capturasVencimiento.forEach(captura=>this.blackbox.addVencimiento(captura))
            this.blackbox.ordenarListaVencimiento()
            this.setState(this.blackbox.getListaFiltradaVencimiento())
        }
        this.getCapturaNoEncontrados=()=>{
            this.blackbox.reset()
            let capturasNoEncontrados = this.state.listaNoEncontrados
            capturasNoEncontrados.forEach(captura=>this.blackbox.addNoEncontrado(captura))
            this.blackbox.ordenarListaNoEncontrados()
            this.setState(this.blackbox.getListaFiltradaNoEncontrados())
        }
        this.actualizarFiltroIRD=(nombreFiltro, filtro)=>{
            this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
            this.setState(this.blackbox.getListaFiltradaIRD())
        }
        this.actualizarFiltroVencimiento=(nombreFiltro, filtro)=>{
            this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
            this.setState(this.blackbox.getListaFiltradaVencimiento())
        }
        this.actualizarFiltroNoEncontrados=(nombreFiltro, filtro)=>{
            this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
            this.setState(this.blackbox.getListaFiltradaNoEncontrados())
        }
        this.ordenarListaIRD=(evt)=>{
            evt.preventDefault()
            this.blackbox.ordenarListaIRD()
            this.setState(this.blackbox.getListaFiltradaIRD())        
        }
        this.ordenarListaVencimiento=(evt)=>{
            evt.preventDefault()
            this.blackbox.ordenarListaVencimiento()
            this.setState(this.blackbox.getListaFiltradaVencimiento())        
        }
        this.informarResultado=()=>{
            let request = api.capturasAuditoria(this.state.auditoria.idAuditoria).informarResultado()
                .then(resp=>{
                this.setState({
                    auditoria: resp
                },()=>this.refs.notificator.success("Auditoria", "Se ha informado correctamente actas pdf por correo.", 5*1000))
            })
            .catch(err=>{
                this.ajaxErrorHandler('Error al informar actas pdf por correo.')
            })
            return request
        }
    }
    getChildContext(){
        return{
            actualizaDatosAuditoria:()=>{
                this.setState({enviando: true})
                // El Panel Vencimiento se guarda con el nombre del auditor en mayúsculas y
                // el rut QF con la 'K' final en mayúsculas (ver panelVencimiento.js)
                let datos = Object.assign({}, this.state.auditoria)
                if (datos.panel_venc)
                    datos.panel_venc = normalizarPanelVenc(datos.panel_venc)
                let request = api.capturasAuditoria(datos.idAuditoria).actualizarDatosAuditoria(datos)
                request
                    .then(auditoria=>{
                        this.setState({
                            auditoria: auditoria,
                            enviando: false
                        },()=>this.refs.notificator.success("Auditoria", "datos auditoria actualizados.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar auditoria.')
                        this.setState({enviando: false})
                    })
                return request
            },
            getImagenesReemplazo:(idCaptura, sku, lote, fecha_exp)=>{
                let request = api.capturasAuditoria(this.state.auditoria.idAuditoria).buscarImagenRemplazo(idCaptura, sku, lote, fecha_exp)
                return request
            },
            reemplazarImagen:(idCapturaVencimientoOriginal, idArchivoImagen)=>{
                let request = api.capturasAuditoria(this.state.auditoria.idAuditoria).postRemplazoImagen(idCapturaVencimientoOriginal, idArchivoImagen)

                return request
            },
            getVencimientos:()=>{
                return this.blackbox.getListaFiltradaVencimiento().capturaVencimientoFiltrada
            },
            actualizaCapturaVencimiento:(captura)=>{
                let request = api.capturasAuditoria(this.state.auditoria.idAuditoria).actualizarVencimiento(captura.idCapturaAuditoriaVencimiento, captura)
                request    
                    .then(resp=>{
                        this.blackbox.actualizaCapturaVencimiento(resp)
                        this.blackbox.ordenarListaVencimiento()
                        this.setState(this.blackbox.getListaFiltradaVencimiento())
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura Vencimiento.')
                    })
                return request
            },
            actualizaCapturaIRD:(captura)=>{
                api.capturasAuditoria(this.state.auditoria.idAuditoria).actualizarIRD(captura.idCapturaAuditoriaIrd, captura)
                    .then(resp=>{
                        this.blackbox.actualizaCapturaIRD(resp)
                        this.blackbox.ordenarListaIRD()
                        this.setState(this.blackbox.getListaFiltradaIRD()) 
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura IRD.')
                    })                  
            },
            actualizarNoEncontrado:(captura)=>{
                api.capturasAuditoria(this.state.auditoria.idAuditoria).actualizarNoEncontrado(captura.idCapturaNoEncontrado, captura)
                    .then(resp=>{
                        this.blackbox.actualizaCapturaNoEncontrado(resp)
                        this.blackbox.ordenarListaNoEncontrados()
                        this.setState(this.blackbox.getListaFiltradaNoEncontrados())
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura IRD.')
                    })
            },
            //Se devuelve la promesa para que el modal de confirmación de la fila
            //espere al backend antes de cerrarse (y bloquee el doble click).
            //La captura IRD no se borra: queda en estado 3 (no válida) y se puede
            //restaurar con el botón de la misma celda.
            eliminarCapturaIRD:(idCapturaAuditoriaIrd)=>{
                return api.capturasAuditoria(this.state.auditoria.idAuditoria).eliminarCapturaIRD(idCapturaAuditoriaIrd)
                    .then(resp=>{
                        this.blackbox.actualizaCapturaIRD(resp)
                        this.blackbox.ordenarListaIRD()
                        this.setState(this.blackbox.getListaFiltradaIRD(),()=>this.refs.notificator.info("Auditoria", "captura marcada como no válida.", 5*1000)) 
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura IRD.')
                    }) 
            },
            restaurarCapturaIRD:(idCapturaAuditoriaIrd)=>{
                api.capturasAuditoria(this.state.auditoria.idAuditoria).restaurarCapturaIRD(idCapturaAuditoriaIrd)
                    .then(resp=>{
                        this.blackbox.actualizaCapturaIRD(resp)
                        this.blackbox.ordenarListaIRD()
                        this.setState(this.blackbox.getListaFiltradaIRD(),()=>this.refs.notificator.success("Auditoria", "captura marcada como restaurada.", 5*1000)) 
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura IRD.')
                    }) 
            },
            eliminarCapturaVencimiento:(idCapturaAuditoriaVencimiento)=>{
                return api.capturasAuditoria(this.state.auditoria.idAuditoria).eliminarCapturaVencimiento(idCapturaAuditoriaVencimiento)
                    .then(resp=>{
                        this.setState({estado_vencimiento: resp.estado_vencimiento})
                        this.blackbox.actualizaCapturaVencimiento(resp.captura_vencimiento)
                        this.blackbox.ordenarListaVencimiento()
                        this.setState(this.blackbox.getListaFiltradaVencimiento(),()=>this.refs.notificator.info("Auditoria", "captura marcada como no válida.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura Vencimiento.')
                    })                
            },
            restaurarCapturaVencimiento:(idCapturaAuditoriaVencimiento)=>{
                return api.capturasAuditoria(this.state.auditoria.idAuditoria).restaurarCapturaVencimiento(idCapturaAuditoriaVencimiento)
                    .then(resp=>{
                        this.setState({estado_vencimiento: resp.estado_vencimiento})
                        this.blackbox.actualizaCapturaVencimiento(resp.captura_vencimiento)
                        this.blackbox.ordenarListaVencimiento()
                        this.setState(this.blackbox.getListaFiltradaVencimiento(),()=>this.refs.notificator.success("Auditoria", "captura marcada como restaurada.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura Vencimiento.')
                    })                
            },
            subirImagenVencimiento: (idCapturaAuditoriaVencimiento, file)=>{
                let data = new FormData()
                data.append('imagen', file)
                let request = api.capturasAuditoria(this.state.auditoria.idAuditoria).subirNuevaImagen(idCapturaAuditoriaVencimiento, data)
                return request    
            },
            eliminarCaptura:()=>{
                this.refs.notificator.info("Auditoria", "eliminando capturas", 5*1000)
                api.capturasAuditoria(this.state.auditoria.idAuditoria).setEliminarCaptura(3)
                    .then(resp=>{
                        this.setState({
                            estado_vencimiento: resp.estado_vencimiento
                        })
                        let capturasVencimiento = resp.captura_vencimiento
                        capturasVencimiento.forEach(captura=>this.blackbox.actualizaCapturaVencimiento(captura))
                        this.blackbox.ordenarListaVencimiento()
                        this.setState(this.blackbox.getListaFiltradaVencimiento())
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura.')
                    })                
            },
            eliminarCapturaDefinitivo:()=>{
                this.refs.notificator.info("Auditoria", "Espere eliminando capturas", 5*1000)
                api.capturasAuditoria(this.state.auditoria.idAuditoria).eliminarCapturasDefinitvo()
                    .then(resp=>{
                        this.blackbox.reset()
                        this.setState(this.blackbox.getListaFiltradaVencimiento())
                        this.refs.notificator.success("Auditoria", "Capturas eliminadas correctamente.", 5*1000)
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({enviando: false})
                        this.ajaxErrorHandler('Error al publicar auditoria.')
                    })
            },
            restaurarCaptura:()=>{
                this.refs.notificator.info("Auditoria", "restaurando capturas", 5*1000)
                api.capturasAuditoria(this.state.auditoria.idAuditoria).setRestaurarCaptura(1)
                    .then(resp=>{ 
                        this.setState({
                            estado_vencimiento: resp.estado_vencimiento
                        })
                        let capturasVencimiento = resp.captura_vencimiento
                        capturasVencimiento.forEach(captura=>this.blackbox.actualizaCapturaVencimiento(captura))
                        this.blackbox.ordenarListaVencimiento()
                        this.setState(this.blackbox.getListaFiltradaVencimiento())
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura.')
                    })                
            },
            publicarAuditoriaVencimiento: ()=>{
                this.setState({enviando: true})
                api.capturasAuditoria(this.state.auditoria.idAuditoria).publicarAuditoriaVencimiento()
                    .then(resp=>{
                        this.setState({
                            auditoria: resp,
                            enviando: false
                        },()=>this.refs.notificator.info("Auditoria", "Resultados de vencimiento publicados exitosamente.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({enviando: false})
                        this.ajaxErrorHandler('Error al publicar auditoria.')
                    })
            },
            publicarAuditoriaIrd: ()=>{
                this.setState({enviando: true})
                api.capturasAuditoria(this.state.auditoria.idAuditoria).publicarAuditoriaIrd()
                    .then(resp=>{
                        this.setState({
                            auditoria: resp,
                            enviando: false
                        },()=>this.refs.notificator.info("Auditoria", "Resultados de ird publicados exitosamente.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({enviando: false})
                        this.ajaxErrorHandler('Error al publicar auditoria.')
                    })
            },
            publicarAuditoriaNoEncontrados: ()=>{
                this.setState({enviando: true})
                api.capturasAuditoria(this.state.auditoria.idAuditoria).publicarAuditoriaNoEncontrados()
                    .then(resp=>{
                        this.setState({
                            auditoria: resp,
                            enviando: false
                        },()=>this.refs.notificator.info("Auditoria", "Resultados de no encontrados publicados exitosamente.", 5*1000))
                    })
                    .catch(err=>{
                        console.log(err)
                        this.setState({enviando: false})
                        this.ajaxErrorHandler('Error al publicar auditoria.')
                    })
            },
            pegarCapturasVencimiento: (data)=>{
                let promesasFetch = []
                data.forEach(nuevaCaptura=> {
                    promesasFetch.push(
                        api.auditoria.nuevaCapturaVencimiento(nuevaCaptura)
                    )
                })
                Promise.all(promesasFetch)
                    .then(capturas=>{
                        api.capturasAuditoria(this.props.idAuditoria).getAuditoria()
                            .then(resp=>{
                                console.log("correcto")
                                this.setState({
                                    auditoria: resp,
                                    estado_vencimiento: resp.estado_vencimiento,
                                    listaIRD:resp.captura_ird,
                                    listaVencimiento: resp.captura_vencimiento,
                                    listaNoEncontrados: resp.captura_no_encontrado
                                })
                                this.getCapturaVencimiento()
                                this.refs.notificator.success("Auditoria", "Capturas pegadas correctamente.", 5*1000)
                            })
                            .catch(err=>{
                                console.log(err)
                                this.ajaxErrorHandler('Error al cargar auditoria.')
                            }) 
                    })
                    .catch(capturas=> {
                        alert('error al buscar la información de los las capturas, (AgregarCapturas desde Excel: fetch todas las capturas correctas)')
                    })
            },
            //Se devuelve la promesa (recarga de la auditoría incluida) para que el
            //modal de confirmación de la fila espere al backend antes de cerrarse.
            //Ojo: el backend elimina el registro (no se puede restaurar).
            eliminarCapturaNoEncontrado: (idNoEncontrado)=>{
                return api.capturasAuditoria(this.state.auditoria.idAuditoria).eliminarCapturaNoEncontrado(idNoEncontrado)
                    .then(resp=>{
                        api.capturasAuditoria(this.props.idAuditoria).getAuditoria()
                            .then(resp=>{
                                console.log("correcto")
                                this.setState({
                                    auditoria: resp,
                                    estado_vencimiento: resp.estado_vencimiento,
                                    listaIRD:resp.captura_ird,
                                    listaVencimiento: resp.captura_vencimiento,
                                    listaNoEncontrados: resp.captura_no_encontrado
                                })
                                this.getCapturaNoEncontrados()
                                this.refs.notificator.success("Auditoria", "No Encontrado eliminado correctamente.", 5*1000)
                            })
                            .catch(err=>{
                                console.log(err)
                                this.ajaxErrorHandler('Error al cargar auditoria.')
                            })
                    })
                    .catch(err=>{
                        console.log(err)
                        this.ajaxErrorHandler('Error al actualizar captura IRD.')
                    })
            }
        }
    }
    componentWillMount(){
        api.capturasAuditoria(this.props.idAuditoria).getAuditoria()
            .then(resp=>{
                this.setState({
                    auditoria: resp,
                    estado_vencimiento: resp.estado_vencimiento,
                    listaIRD:resp.captura_ird,
                    listaVencimiento: resp.captura_vencimiento,
                    listaNoEncontrados: resp.captura_no_encontrado
                })
            })
            .catch(err=>{
                console.log(err)
                this.ajaxErrorHandler('Error al cargar auditoria.')
            })
    }
    render() {
        const listaV = this.state.listaVencimiento.length > 0 ? this.state.listaVencimiento.filter((ven) => {
            return ven.vencido == 1;
        }) : [];

        const btnVencimientoClass = cx("btnRevision", {
            "active": this.state.showVencimiento,
            "alerta": listaV.length > 0 && !this.state.auditoria.realizada_informada
        });
        return (
            <div className="container">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <div className="page-header row">
                    <div className={cx("col-md-12", 'tituloAuditoria')}>
                        <div className={cx("col-md-3", 'divTitulo')}>
                            <h2>Auditoria {this.state.auditoria.local_cliente}: <b>{this.state.auditoria.local_ceco}</b></h2>
                        </div>
                        <div className={cx("col-md-8", 'divNavBar')}>
                            <ul className={cx("nav nav-pills navbar-right", 'navRevision')}>
                                <li role="presentation" className={cx(this.state.showIRD? "active": null,'btnRevision')}><a onClick={this.mostrarIRD}>Revisar IRD</a></li>
                                <li role="presentation" className={btnVencimientoClass}>
                                    <a onClick={this.mostrarVencimiento}>Revisar Vencimiento</a>
                                </li>
                                <li role="presentation" className={cx(this.state.showNoEncontrados? "active": null,'btnRevision')}><a onClick={this.mostrarNoEncontrados}>Revisar No Encontrados</a></li>
                            </ul>
                            {!this.props.fcv ? <BotonInformar
                                estadoInformada={this.state.auditoria.realizada_informada}
                                onClick={this.informarResultado}
                            /> : null}
                            {listaV.length > 0 && !this.state.auditoria.realizada_informada ? <label className={cx('mensajesPendientes')}>Revisar Vencimiento</label>  : null}
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                {this.state.showVencimiento || this.state.showNoEncontrados
                    ? <PanelAuditoria
                        datosAuditoria={this.state.auditoria.panel_venc ? this.state.auditoria.panel_venc : []}
                        onInputChange={this.onInputChangeVenc}
                        linkEjecutado={this.state.auditoria.linkEjecutado}
                        foto_acta={this.state.auditoria.ruta_acta}
                        title="Panel Vencimiento"
                        esVencimiento={true}
                        canChange={this.state.auditoria.cambiarImagen}
                        usuario_android = {this.state.auditoria.usuario_android}
                        fcv={this.props.fcv}
                        auditoria={this.state.auditoria}
                    />
                    : <PanelAuditoria
                        datosAuditoria={this.state.auditoria}
                        onInputChange={this.onInputChange}
                        linkEjecutado={this.state.auditoria.linkEjecutado}
                        foto_acta={this.state.auditoria.ruta_acta}
                        title="Panel IRD"
                        canChange={this.state.auditoria.cambiarImagen}
                        usuario_android = {this.state.auditoria.usuario_android}
                        fcv={this.props.fcv}
                    />
                }
                </div>
                {this.state.showIRD && !this.state.enviando ?
                    <TablaIRD
                        filtros={this.state.filtrosIRD}
                        actualizarFiltro={this.actualizarFiltroIRD.bind(this)}
                        capturaIRDFiltrada={this.state.capturaIRDFiltrada}
                        revisado={this.state.auditoria.ird_revisado}
                        fcv={this.props.fcv}
                    />
                    :
                    null
                }
                {this.state.showVencimiento && !this.state.enviando?
                    <TablaVencimiento
                        filtros={this.state.filtrosVencimiento}
                        actualizarFiltro={this.actualizarFiltroVencimiento.bind(this)}
                        capturaVencimientoFiltrada={this.state.capturaVencimientoFiltrada}
                        estado_vencimiento={this.state.estado_vencimiento}
                        revisado={this.state.auditoria.vencimiento_revisado}
                        local={this.state.auditoria.local_ceco}
                        auditor={this.state.auditoria.auditor}
                        idArchivoFinalAuditoria={this.state.auditoria.idArchivoFinalAuditoria}
                        idAuditoria={this.state.auditoria.idAuditoria}
                        fcv={this.props.fcv}
                    />
                    :
                    null
                }
                {this.state.showNoEncontrados && !this.state.enviando?
                    <TablaNoEncontrados
                        filtros={this.state.filtrosNoEncontrados}
                        actualizarFiltro={this.actualizarFiltroNoEncontrados.bind(this)}
                        capturaNoEncontradosFiltrada={this.state.capturaNoEncontradosFiltrada}
                        local={this.state.auditoria.local_ceco}
                        auditor={this.state.auditoria.auditor}
                        revisado={this.state.auditoria.no_encontrados_revisado}
                        fcv={this.props.fcv}
                    />
                    :
                    null
                }
            </div>
        )
    }
}
RevisionArchivoFinal.childContextTypes = {
    actualizaDatosAuditoria: PropTypes.func,
    getImagenesReemplazo: PropTypes.func,
    reemplazarImagen: PropTypes.func,
    getVencimientos: PropTypes.func,
    actualizaCapturaIRD: PropTypes.func,
    actualizaCapturaVencimiento: PropTypes.func,
    eliminarCapturaIRD: PropTypes.func,
    restaurarCapturaIRD: PropTypes.func,
    eliminarCapturaVencimiento: PropTypes.func,
    restaurarCapturaVencimiento: PropTypes.func,
    eliminarCaptura: PropTypes.func,
    eliminarCapturaDefinitivo: PropTypes.func,
    restaurarCaptura: PropTypes.func,
    publicarAuditoriaVencimiento: PropTypes.func,
    publicarAuditoriaIrd: PropTypes.func,
    publicarAuditoriaNoEncontrados: PropTypes.func,
    subirImagenVencimiento: PropTypes.func,
    actualizarNoEncontrado: PropTypes.func,
    pegarCapturasVencimiento: PropTypes.func,
    eliminarCapturaNoEncontrado: PropTypes.func
}
const BotonInformar = ({onClick, estadoInformada})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className={cx(estadoInformada?'btn btn-md btn-success': 'btn btn-md btn-warning', 'btnGuardar')} onClick={showModal} disabled={false}>
                <span className={'glyphicon glyphicon-envelope'}/>
                {estadoInformada? ' Informada' : ' Informar Resultados'}
                {isVisible && <ModalInformarResultado
                    hideModal={hideModal}
                    onClick={onClick}
                />}
            </button>
        }
    </ModalTrigger>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/RevisionArchivoFinal.jsx